import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppService } from '../app.service';
import { CONSTANT_VALUES } from './../constants/constant-values';
import { HandleSideMenuWithAuth } from './message.event';
@Injectable()
export class AuthGuard implements CanActivate {
    private authGuard: Object = {
        'signup': [CONSTANT_VALUES.SUPER_ADMIN],
        'facility': [CONSTANT_VALUES.SUPER_ADMIN],
        'addfacility': [CONSTANT_VALUES.SUPER_ADMIN],
        'addmember': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'member': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'calendar': [CONSTANT_VALUES.ROLE_STAFF, CONSTANT_VALUES.ROLE_VENDOR_ADMIN, CONSTANT_VALUES.SUPER_ADMIN],
        'logout': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN, CONSTANT_VALUES.ROLE_STAFF, CONSTANT_VALUES.SUPER_ADMIN],
        'creategroup': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'disablemember': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'memberdetail': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'activemember': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'feedback': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'group': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'managegroup': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'feedbacklist': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'broadcast': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'alert': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'feed': [CONSTANT_VALUES.ROLE_VENDOR_ADMIN],
        'vendor-profile': [CONSTANT_VALUES.ROLE_STAFF, CONSTANT_VALUES.ROLE_VENDOR_ADMIN, CONSTANT_VALUES.SUPER_ADMIN]
    };

    private defaultRouteForRole = {
        'vendor admin': 'member',
        'staff': 'calendar',
        'superAdmin': 'facility'
    };

    constructor(private router: Router, private appService: AppService, public handleSideMenuWithAuth: HandleSideMenuWithAuth, ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.sessionCheck() && this.authenticateUser()) {
                return true;
        } else {
            this.router.navigate(["/"]);
            return false;
        }
    }

    sessionCheck() {
        if (localStorage.getItem('vendor') && atob(localStorage.getItem('vendor')) !== 'undefined') {
            return (true);
        } else {
            this.router.navigate(['/']);
            return (false);
        }
    }

    authenticateUser() {
        let vendorData = localStorage.getItem('vendor');
        if (vendorData) {
            let vendor = JSON.parse(atob(vendorData));
            let route = location.pathname.replace('/', '');
            this.renderRoleWiseAppMenu(vendor.role);
            if (route == 'feedbacklist' && !vendor.isFeedbackEnabled) {
                return false;
            }
            if (this.authGuard[route]) {
                if (this.authGuard[route].indexOf(vendor.role) > -1) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    navigateUserToDefaultRoute() {
        let vendorData = localStorage.getItem('vendor');
        let vendor = JSON.parse(atob(vendorData));
        this.router.navigate(['/' + this.defaultRouteForRole[vendor.role]]);
    }

    renderRoleWiseAppMenu(role) {
        let vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        if (vendor['isFirstTimeLogin'] && vendor.role == 'vendor admin') {
            role = 'wizard'
        }
        this.handleSideMenuWithAuth.fire({ fire: 'on', role: role, isFeedbackEnabled: vendor.isFeedbackEnabled });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth-guard.ts